import { createReducer, on } from '@ngrx/store';
import {
  addFavorite,
  clearAllSelfAssessedRequirements,
  clearFavorites,
  clearSelfAssessedBicId,
  removeFavorite,
  resetSelfAssessedRequirementsTimeout,
  setAcceptCookieDate,
  setFavoritesCode,
  toggleFavorite,
  toggleSelfAssessedRequirement,
  updateSelfAssessedRequirementsTimeout
} from "../actions/user.actions";
import {SelfAssessedReqRow} from "../../interfaces/self-assessed-req-row";
import {EntityType} from "../../enums/entity-type";
import {FavoriteEntity} from "../../interfaces/favorite-entity";

export const userFeatureKey = 'user';

export interface UserState {
  favorites: FavoriteEntity[];
  favoritesCode: string;
  selfAssessedRequirements: SelfAssessedReqRow[];
  selfAssessedRequirementsTimeout: number;
  cookieAcceptDate: number;
}

export const initialState: UserState = {
  favorites: new Array(0),
  selfAssessedRequirementsTimeout: -1,
  favoritesCode: "",
  selfAssessedRequirements: new Array(0),
  cookieAcceptDate: 0
};

export const reducer = createReducer(
  initialState,
  on(toggleFavorite, (state, action) => {
    let currentState = state.favorites;

    let newState: FavoriteEntity[] = [];
    if(currentState.findIndex(el => el.id === action.id) === -1) {
      newState = [...currentState, {id: action.id, type: action.entityType}];
    } else {
      newState = currentState.filter((el) => el.id !== action.id);
    }

    return {
      ...state,
      favorites: newState
    }

  }),
  on(addFavorite, (state, action) => {
    let currentState = state.favorites;
    let newState = [...currentState];
    if(newState.findIndex(el => el.id === action.id) === -1) {
      newState.push({id: action.id, type: action.entityType});
    }
    return {
      ...state,
      favorites: newState
    };
  }),

  on(removeFavorite, (state, action) => {

    let currentState = state.favorites;
    let newState = [...currentState];
    const targetIndex = newState.findIndex(el => el.id === action.id);
    if(targetIndex !== -1) {
      newState.splice(targetIndex, 1);
    }

    return {
      ...state,
      favorites: newState
    };
  }),

  on(setFavoritesCode, (state, action) => {

    return {
      ...state,
      favoritesCode: action.code
    };
  }),

  on(clearFavorites, (state, action) => {

    return {
      ...state,
      favorites: []
    };
  }),

  on(toggleSelfAssessedRequirement, (state, action) => {

    const {bicId, requirementId} = action;
    const currentState: SelfAssessedReqRow[]  = JSON.parse(JSON.stringify(state.selfAssessedRequirements));
    const bicIdRowIdx = currentState.findIndex((row) => row.bicId === bicId);

    if(bicIdRowIdx === -1) {
      const bicIdRow: SelfAssessedReqRow = {bicId: bicId, reqIds: [requirementId]};
      currentState.push(bicIdRow);
    } else {
      if(currentState[bicIdRowIdx].reqIds.includes(requirementId)) {
        currentState[bicIdRowIdx].reqIds = currentState[bicIdRowIdx].reqIds.filter((el) => el !== requirementId);
      } else {
        currentState[bicIdRowIdx].reqIds = [...currentState[bicIdRowIdx].reqIds, requirementId];
      }
    }
    return {
      ...state,
      selfAssessedRequirements: [...currentState]
    };
  }),
  on(clearSelfAssessedBicId, (state, action) => {

    const {bicId} = action;
    let currentState: SelfAssessedReqRow[]  = JSON.parse(JSON.stringify(state.selfAssessedRequirements));
    const bicIdRowIdx = currentState.findIndex((row) => row.bicId === bicId);

    currentState.splice(bicIdRowIdx, 1);
    // console.log(currentState);
    return {
      ...state,
      selfAssessedRequirements: [...currentState]
    };
  }),
  on(clearAllSelfAssessedRequirements, (state, action) => {
    return {
      ...state,
      selfAssessedRequirements: []
    };
  }),
  on(updateSelfAssessedRequirementsTimeout, (state, action) => {
    return {
      ...state,
      selfAssessedRequirementsTimeout: Date.now() + (30 * 60 * 1000) // 30 mins
      // selfAssessedRequirementsTimeout: Date.now() + (10 * 1000) // 10 secs
    };
  }),
  on(resetSelfAssessedRequirementsTimeout, (state, action) => {
    return {
      ...state,
      selfAssessedRequirementsTimeout: -1
    };
  }),
  on(setAcceptCookieDate, (state) => {
    return {
      ...state,
      cookieAcceptDate: Date.now()
    };
  })
);
